// @ts-strict-ignore
import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {purgeFetchCache} from 'common/report/queries/utils/fetch-cache';

import {appApiUrl} from '../utils';

export type TopCreator = {
  id: number;
  email: string;
  name: string;
  total_view_count: number;
  dashboards_count: number;
  bookmarks_count: number;
};

export type ProjectTopCreatorsResponse = {creators: TopCreator[]; has_viewed_content: boolean};

function getUrl(projectId: string) {
  return appApiUrl(`top-creators`, {projectId});
}

export const projectTopCreatorsClient: ApiResourceClient<ProjectTopCreatorsResponse> = {
  index() {
    throw new Error(`projectTopCreatorsClient does not support index queries`);
  },

  get(id: string) {
    return apiClient.hydratedGet<ProjectTopCreatorsResponse>(getUrl(id));
  },

  purgeCache(id: string) {
    purgeFetchCache({everything: true, path: getUrl(id)});
  },
};
